module.exports = __webpack_public_path__ + "static/media/3.20_preview.b0e3cab1.png";